var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHamburger = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 14,
  viewBox: "0 0 18 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 1.8,
  rx: 0.9,
  fill: "#4F4F4F"
}), /*#__PURE__*/React.createElement("rect", {
  y: 5.39844,
  width: 18,
  height: 1.8,
  rx: 0.9,
  fill: "#4F4F4F"
}), /*#__PURE__*/React.createElement("rect", {
  y: 11.6992,
  width: 18,
  height: 1.8,
  rx: 0.9,
  fill: "#4F4F4F"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 13.5,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHamburger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hamburger.150a3c8f.svg";
export { ForwardRef as ReactComponent };